export function useApi() {
  return {
    page: usePage(),
    tag: useTag(),
    routing: useRouting(),
  }
}
